import {http} from "../utils/http";

export const createNewUserApi = async (data) => {
  try {
    return await http.post("/User/save", {
      id: 0,
      ...data,
    });
  } catch (error) {}
};

export const getUserListApi = async (data) => {
  try {
    return await http.get("/User/list", {
      params: data,
    });
  } catch (error) {}
};

export const getProfileApi = async (id) => {
  try {
    const res = await http.get(`/User/${id}/get-profile`);
    return res?.data;
  } catch (error) {}
};

export const bulkDeleteUsersApi = async (data) => {
  try {
    return await http.delete("/User/delete", {
      data: data,
    });
  } catch (error) {}
};
